import { defineComponent as _defineComponent } from 'vue'

import { Studio } from '@/modules/Studios/types'
import StudiosGridChip from '@/modules/Studios/components/lists/StudiosGridChip.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudiosGridView',
  props: {
    studios: null,
    ownStudios: null
  },
  setup(__props: any) {



return { __sfc: true,StudiosGridChip }
}

})